const SETTLEMENTS_TABLE_HEADERS = [
  {
    name: 'Settlement Address',
    column: 'settlement_address'
  },
  {
    name: 'Amount Requested',
    column: 'amount_requested'
  },
  {
    name: 'Settlement Amount',
    column: 'amount_to_be_settled'
  },
  {
    name: 'Reference',
    column: 'reference'
  },
  {
    name: 'Date',
    column: 'created_at',
    filter: 'date'
  },
  {
    name: 'Status',
    column: 'status'
  }
];

// if there are more properties that need to be added to admin settlement headers, avoid appending the property this way and create it's own config from scratch
const ADMIN_SETTLEMENTS_TABLE_HEADERS = [
  { name: 'Merchant', column: 'merchant_name' },
  ...SETTLEMENTS_TABLE_HEADERS
];

const SETTLEMENT_STATUSES = [
  {
    label: 'All Settlements',
    value: ''
  },
  {
    label: 'Pending',
    value: 'PENDING'
  },
  {
    label: 'Successful',
    value: 'SUCCESSFUL'
  },
  {
    label: 'Failed',
    value: 'FAILED'
  }
];

export { ADMIN_SETTLEMENTS_TABLE_HEADERS, SETTLEMENT_STATUSES, SETTLEMENTS_TABLE_HEADERS };
